// Core Modules
import { inject, Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

// External Modules
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// Tokens
import { WINDOW } from '@core/injection-tokens/tokens';

// Enums
import { LocalStorageEnum } from '@shared/enum/local-storage-keys.enum';
import { MainNavigationEnum } from '@shared/enum/main-navigation-url.enum';
import { UserProfileFieldsEnum } from '@shared/enum/user-profile-fields.enum';

@Injectable({
  providedIn: 'root',
})
export class StorageTrackerService implements OnDestroy {
  // Injectors
  private readonly ngbModal = inject(NgbModal);
  private readonly router = inject(Router);
  private readonly window = inject(WINDOW);

  constructor() {
    this.stop();
    this.start();
  }

  private start(): void {
    this.window.addEventListener('storage', this.storageEventListener.bind(this));
  }

  private storageEventListener(event: StorageEvent): void {
    // Reload the page on below conditions for multiple tabs open
    // 1. Reload on change in user_profile value in local storage
    // 2. Reload the page on clear of local storage
    if (event.storageArea === localStorage) {
      if (event.key === null && event.newValue === null) {
        this.ngbModal.dismissAll('Logged out');
        this.router.navigate([`/${MainNavigationEnum.LOGIN}`], {
          onSameUrlNavigation: 'reload',
        });
      }
      if (event.key === LocalStorageEnum.USER_PROFILE && event.newValue && JSON.parse(event.newValue)[UserProfileFieldsEnum.EMAIL]) this.window.location.reload();
    }
  }

  public stop(): void {
    this.window.removeEventListener('storage', this.storageEventListener.bind(this));
  }

  public ngOnDestroy(): void {
    this.stop();
  }
}
